import {connectionPModulesValues} from '@/api/configApi';
import {SocketManager} from '@/utils/socketUtils';

declare module 'vue/types/vue' {
  interface Vue {
    $dataSocketManager: SocketManager;
  }
}

export default {
  install: (Vue: any) => {
    Vue.prototype.$dataSocketManager = new SocketManager(connectionPModulesValues);
  },
};
